import { IconButton, useMediaQuery, useTheme } from "@mui/material";

const LifelineButton = ({
  isActive,
  isUsed,
  icon,
}: {
  isActive: boolean;
  isUsed: boolean;
  icon: React.ReactNode;
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <IconButton
      size={isMobile ? "small" : "medium"}
      sx={{
        animation: isActive ? "pulse 1.5s infinite" : "none",
        height: "50px",
        width: "50px",
        "@keyframes pulse": {
          "0%": { boxShadow: "0 0 0 0 rgba(145, 49, 117, 0.7)" },
          "70%": { boxShadow: "0 0 0 10px rgba(145, 49, 117, 0)" },
          "100%": { boxShadow: "0 0 0 0 rgba(145, 49, 117, 0)" },
        },
        backgroundColor: isUsed ? "#616161" : theme.palette.primary.main,
        color: isUsed ? "#bdbdbd" : "#fff",
        border: isUsed
          ? "2px solid #bdbdbd"
          : `2px solid ${theme.palette.primary.main}`,
        padding: { xs: "4px", sm: "6px" },
        boxShadow: isUsed ? "none" : "0 2px 4px rgba(0, 0, 0, 0.2)",
        opacity: isUsed ? 0.6 : 1,
        "&:hover": {
          backgroundColor: isUsed ? "#616161" : theme.palette.primary.dark,
        },
      }}
    >
      {icon}
    </IconButton>
  );
};

export default LifelineButton;
